import { SortParams } from '@epicuro-next/data/baskets';
import { createAction, props } from '@ngrx/store';
import {
  BasketGroupSortType,
  BasketRowsGroupType,
} from 'graphql-api/baskets-api-interfaces';

/**
 * Grouping the basket with a user selected grouping field
 */

export const triggerBasketGroupingChanged = createAction(
  '[Basket] Trigger Grouping Changed',
  props<{ groupingType: BasketRowsGroupType }>(),
);

export const basketGroupingChanged = createAction(
  '[Basket] Grouping Changed',
  props<{ groupingType: BasketRowsGroupType }>(),
);

export const resolveActiveBasketComplete = createAction(
  '[Basket] Resolve Active Basket Complete',
);

export const initSortingBasketItems = createAction(
  '[Basket] Initialize Sorting Basket Items',
  props<{ sorting: Required<SortParams> }>(),
);

export const triggerSortingBasketItems = createAction(
  '[Basket] Trigger Sorting Basket Items',
  props<{ sorting: BasketGroupSortType }>(),
);

export const applySortingBasketItems = createAction(
  '[Basket] Apply Sorting Basket Items',
  props<{ sorting: Required<SortParams> }>(),
);
